import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2b4009',
        secondary: '#c4ca3f',
        accent: '#c4ca3f',
        error: colors.red.base,
        warning: colors.amber.base,
        info: colors.blueGrey.base,
        success: colors.green.base,
        anchor: '#2b4009',
        tertiary: '#ffffff',
        white: '#ffffff',
        dark: '#111111',
        black: '#000000'
      }
    }
  }
});
